// @flow
import { DefaultTheme } from 'styled-components';

const mainTheme: DefaultTheme = {
  spacing: {
    containerPadding: '20px',
  },
  colors: {
    lighterBlue: '#1a6aff',
    boldBlue: '#124ab2',
    shadesBlue: '#5F97FF',
    babyBlue: '#86D3FF',
    mainBlue: '#3e75c8',
    mainFontColor: '#16183a',
    mutedColor: '#454b60',
    neutralBlack: '#222222',
    lightGray: '#c4c4c4',
    grayNeutralLight: '#595760',
    darkCharcoal: '#333333',
    superSilver: '#EEEEEE',
    gullGrey: '#84858b',
    lighterRed: '#dc3545',
    coralPink: '#FF8591',
    black: '#000000',
    white: '#ffffff',
    lightSilver: '#dcdcdc',
    green: '#218838',
    shadesYellow: '#EFDCAD',
    lightBlue: '#E3EDFF',
    orange: '#E59722',
    whiteSmoke: '#EFEFEF',
    shadesInquirerBlue: '#BAD2FF',
    deepBlue: '#002659',
    deepIndigo: '#1E163B',
    // Homepage / shared UI
    textPrimary: '#3e3f42',
    borderLight: '#eaedf3',
    backgroundLight: '#f5f5f5',
    backgroundHover: '#f0f0f0',
    sidebarIconBg: '#D9D5F2',
    // Homepage tool card accent palette
    cardAccentLavender: '#CBCDF3',
    cardAccentMint: '#A7D9D6',
    cardAccentPink: '#F8E0EF',
    cardAccentRose: '#E5A9CF',
    cardAccentBlue: '#BAD2FF',
    cardAccentYellow: '#EFDCAD',
    cardAccentPeach: '#ECC7B0',
    cardAccentPlum: '#CCB2D0',
    cardAccentGray: '#DCDCDC',
    backgroundMuted: '#F4F4F4',
    // Notification Assistant / AI-assisted UI palette (Tailwind-derived).
    // Slate neutral scale (surfaces, borders, text)
    slate50: '#f8fafc',
    slate200: '#e2e8f0',
    slate300: '#cbd5e1',
    slate400: '#94a3b8',
    slate500: '#64748b',
    slate600: '#475569',
    slate700: '#334155',
    slate900: '#0f172a',
    gray500: '#6b7280',
    canvasSubtle: '#fafbfc',
    surfaceMuted: '#eef1f5',
    borderCard: '#eceff3',
    borderMuted: '#e2e6ec',
    borderInput: '#dfe3e8',
    placeholderText: '#b6bdc7',
    // Indigo / violet / sky (AI accent + gradient)
    indigo50: '#eef2ff',
    indigo300: '#a5b4fc',
    indigo500: '#6366f1',
    indigo600: '#4f46e5',
    violet50: '#f5f3ff',
    violet200: '#ddd6fe',
    violet500: '#8b5cf6',
    violet700: '#6d28d9',
    sky500: '#0ea5e9',
    cyan50: '#ecfeff',
    // Green / emerald (success, "copied", loaded)
    green50: '#f0fdf4',
    green200: '#bbf7d0',
    green300: '#86efac',
    green600: '#16a34a',
    green700: '#15803d',
    emerald50: '#ecfdf5',
    emerald200: '#a7f3d0',
    emerald600: '#059669',
    emerald800: '#065f46',
    // Rose / red (danger, "fail")
    rose50: '#fff1f2',
    rose200: '#fecdd3',
    rose600: '#e11d48',
    red50: '#fef2f2',
    red200: '#fecaca',
    red600: '#dc2626',
    red700: '#b91c1c',
    // Amber (warning, acknowledgment, editorial feedback)
    amber50: '#fffbeb',
    amber200: '#fde68a',
    amber700: '#b45309',
    amber800: '#92620a',
  },
};

export default mainTheme;

